import { API_BASE_URL } from "../config/apiBaseUrl";

const ADMIN_BASE = "/api/admin/automotive";
const PORTAL_BASE = "/api/v1/automap/dealer-portal";

function authHeaders() {
  return { credentials: "include" };
}

function qs(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") search.set(key, value);
  });
  const query = search.toString();
  return query ? `?${query}` : "";
}

export async function fetchFoundingDashboard() {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/founding`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar el dashboard fundador.");
  return res.json();
}

export async function fetchFoundingPipeline(params = {}) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/founding/pipeline${qs(params)}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar el pipeline.");
  return res.json();
}

export async function createFoundingProspect(payload) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/founding/pipeline`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("No se pudo crear el prospecto.");
  return res.json();
}

export async function updateFoundingPipelineRecord(recordId, payload) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/founding/pipeline/${recordId}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("No se pudo actualizar el registro.");
  return res.json();
}

export async function convertFoundingPipelineRecord(recordId, payload = {}) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/founding/pipeline/${recordId}/convert`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("No se pudo convertir a concesionario.");
  return res.json();
}

export async function fetchFoundingReadiness() {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/founding/readiness`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar readiness del cohorte.");
  return res.json();
}

export async function fetchFoundingImports() {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/founding/imports`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar tracker de importaciones.");
  return res.json();
}

export async function fetchFoundingTasks(params = {}) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/founding/tasks${qs(params)}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar tareas.");
  return res.json();
}

export async function createFoundingTask(payload) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/founding/tasks`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("No se pudo crear la tarea.");
  return res.json();
}

export async function updateFoundingTask(taskId, payload) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/founding/tasks/${taskId}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("No se pudo actualizar la tarea.");
  return res.json();
}

export async function fetchAdminDealerOnboarding(dealerId) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/${dealerId}/onboarding`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar onboarding del dealer.");
  return res.json();
}

export async function updateAdminDealerChecklistItem(dealerId, itemKey, payload) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/${dealerId}/onboarding/${itemKey}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("No se pudo actualizar el checklist.");
  return res.json();
}

export async function markDealerLaunchReady(dealerId) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/${dealerId}/onboarding/mark-launch-ready`, {
    method: "POST",
    credentials: "include",
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || "No se pudo marcar launch-ready.");
  }
  return res.json();
}

export async function fetchFoundingDealerPanel(dealerId) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/${dealerId}/founding`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar panel fundador.");
  return res.json();
}

export async function fetchDealerPortalOnboarding(dealerId) {
  const res = await fetch(`${API_BASE_URL}${PORTAL_BASE}/dealers/${dealerId}/onboarding`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar tu onboarding.");
  return res.json();
}

export async function updateDealerPortalChecklistItem(dealerId, itemKey, payload) {
  const res = await fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/onboarding/${encodeURIComponent(itemKey)}`,
    {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(payload),
    }
  );
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || "No se pudo actualizar el checklist.");
  }
  return res.json();
}

export async function fetchOutreachTemplates() {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/dealers/founding/outreach-templates`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar plantillas.");
  return res.json();
}
